/**
 * Builds a stepId lookup for a flow's WIREFRAME_STEPS array.
 * stepId values are persisted in MongoDB — do not rename; add new entries instead.
 */
export const createStepRegistry = ({ metaByComponent, contextFieldsByStepId = {} }) => {
  const getStepMeta = (stepDef) => {
    const component = stepDef?.component;
    const known = component ? metaByComponent.get(component) : null;
    if (known) {
      return { ...known };
    }

    const fallbackLabel = component?.displayName || component?.name || "unknown_step";
    return {
      id: `unknown_${fallbackLabel}`,
      phase: "unknown",
    };
  };

  const getStepMetaAtIndex = (steps, stepIndex) => {
    const stepDef = steps?.[stepIndex];
    if (!stepDef) {
      return {
        id: "unknown_step",
        phase: "unknown",
      };
    }
    return getStepMeta(stepDef);
  };

  const getStepContextFieldKeys = (stepId) =>
    contextFieldsByStepId[stepId] ? [...contextFieldsByStepId[stepId]] : [];

  return { getStepMeta, getStepMetaAtIndex, getStepContextFieldKeys };
};
